import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { SignedEditionListStore } from "../../store/SignedEditionListStore";

type SignedEditionListDialogsProps = {
  store: SignedEditionListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de SignedEdition.
 * Separado para mantener SignedEditionListPage más limpio.
 */
export const SignedEditionListDialogs: React.FC<SignedEditionListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
